import storyPitchingService from './story-pitching-service/storyPitchingService';

const toLoad = [
  storyPitchingService
];

export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
